export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_06.75b62659.jpg";